module.exports = require('./PageCalendar');



/** WEBPACK FOOTER **
 ** ./demo/src/pages/calendar/index.js
 **/